module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-table-flower-99538b1dc30a1984170f92e626bc0088.jpg";